<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
      dense
      v-if="getLogeado"
      class ="ma-5 mt-3" 
      style="border-radius: 10px;"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      Sistema de administración
      <v-spacer></v-spacer>
      <v-btn text icon v-if="getLogeado" @click="salir"><v-icon>mdi-exit-to-app</v-icon></v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <!-- Menu lateral izquierdo -->
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      v-if="getLogeado"
      class="elevation-3 mt-3 pb-5"
      style="border-radius: 10px;"
    >

      <v-list-item class="pt-4 px-1" >
        <v-list-item-content>
          <v-img src="https://mikai.mx/wp-content/uploads/2022/06/mikai-logo-2.png" v-if="!mini"></v-img>
          <v-avatar
            size="40"
            v-else="mini"
            color="white"
          >
            <img src="https://www.mikai.mx/wp-content/uploads/2017/08/cropped-favicon-1-32x32.png">
          </v-avatar>
        </v-list-item-content>

        <v-btn icon @click.stop="mini = !mini" color="primary">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item class="px-2" @click="verMiPerfil( )">
        <v-list-item-avatar>
          <v-img
            :src="avatar"
          ></v-img>
        </v-list-item-avatar>

        <v-list-item-content v-if="getdatosUsuario">
          <v-list-item-title>
            {{ getdatosUsuario.nombre_completo }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ getdatosUsuario.puesto }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav class="mr-0">
        <v-list-item-group
          v-for="item in menu"
          :key="item.title"
          v-model="selectedItem"
        >
          <v-list-item
            color="primary"
            v-for="child in item.items"
            :key="child.title"
            :to="{ name: child.name }"
            v-if="child.permisos.includes( getdatosUsuario.admin ) "
            :class="`pl-2 ${ child.color ? child.color : 'grey lighten-3' }`"
          >

            <v-list-item-icon>
              <v-icon color="primary">mdi mdi-circle-medium theme--light</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <!-- REGLAMENTO -->
      <v-list dense nav class="mr-0">
        <v-list-item @click="salir" class="primary white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      


    </v-navigation-drawer>

  </v-app>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    name: 'App',

    components: {
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({
      //
      model: null,
      dialog: false,
      draw: false,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      radio:1,
      drawer: true,
      drawer2:false,
      mini:false,

      accesos: [],
      selectedItem: null
     
    }),

    created( ){
    },

    methods:{
      ...mapActions('login',['salirLogin']),

      salir(){
        this.salirLogin()
        this.$router.push({name:'login'})
      },

      verMiPerfil( ){

        this.$router.push({
          name: 'MiPerfil'
        })

      },
    },

    computed:{
      ...mapGetters('login',['getdatosUsuario','getLogeado']),

      avatar(){
        return "https://ui-avatars.com/api/?background=primary&color=fff&rounded=true&format=svg&name=" + this.getdatosUsuario.nombre_completo
      },

      accesoWataje( ){
        const existenAccesos = this.accesos.find( el => el.id == this.getdatosUsuario.idusuarios )

        let permisos = existenAccesos ? existenAccesos.accesos : []

        return permisos.find( el => el.idruta == 3 )
      },

      menu(){


        let menuContext = []

        menuContext.push({ 
          title: "Catálogos",
          icon: "mdi-account", 
          items:[
            { title: "Usuarios"           , icon: "mdi-account"             , name: "Usuarios"          , permisos: ['ADMIN'] },
            // { title: "Departamentos"      , icon: "mdi-account"             , name: "Departamentos"     , permisos: ['ADMIN'] },
            // { title: "Proveedores"        , icon: "mdi-account"             , name: "Proveedores"       , permisos: ['ADMIN'] },
            // { title: "Articulos"          , icon: "mdi-account"             , name: "Articulos"         , permisos: ['ADMIN'] },
            // { title: "Platillos"          , icon: "mdi-account"             , name: "Platillos"         , permisos: ['ADMIN'] },
            // { title: "Sucursales"         , icon: "mdi-account"             , name: "Sucursales"        , permisos: ['ADMIN'] },
            // { title: "Extras"             , icon: "mdi-account"             , name: "Extras"            , permisos: ['ADMIN'] },
            { title: "Clientes"           , icon: "mdi-account"             , name: "Clientes"          , permisos: ['ADMIN','SUPERVISOR'] },
            { title: "Proyectos"          , icon: "mdi-account"             , name: "Proyectos"         , permisos: ['ADMIN','SUPERVISOR'] },
            // { title: "Forms"              , icon: "mdi-account"             , name: "Forms"             , permisos: ['ADMIN','SUPERVISOR','USUARIO'] },
            // { title: "Ventas Contratos"   , icon: "mdi-account"             , name: "Contratos"         , permisos: ['ADMIN','SUPERVISOR'] },
            // { title: "Ventas Mercancia"   , icon: "mdi-account"             , name: "VentasMercancia"   , permisos: ['ADMIN','SUPERVISOR'] },
            // { title: "Agenda"             , icon: "mdi-account"             , name: "FechasBloqueadas"  , permisos: ['ADMIN','SUPERVISOR'] },
          ]      
        })

        return menuContext

      }
    }
  };
</script>
<style>

  main{
    background: #f8f9fa ;
  }

  .v-navigation-drawer__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-navigation-drawer__content::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-button:increment,.v-navigation-drawer__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  html{
    background: #f8f9fa;
  }

  .v-main__wrap{
    background: #f8f9fa !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }


  .subrayado {
    text-decoration: underline;
  }

  #idScrollApp::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #idScrollApp::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-button:increment,#idScrollApp::-webkit-scrollbar-button{
    display: none;
  }

  #idScrollApp::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  a .v-list-item .v-list-item--link .theme--light{
    padding-left: 0px !important;
  }

</style>